import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { publicAxios } from '@/lib/axios'
import { handleApiError, MutationConfig } from '@/lib/react-query'
import { PublicDto } from '@/types'

const resendUserActivation = (data: PublicDto['ResendUserActivationCommand']): Promise<PublicDto['AuthSessionDto']> => {
  return publicAxios.post('/auth/resend-activation', data)
}

type UseResendUserActivationOptions = {
  config?: MutationConfig<typeof resendUserActivation>
}

export const useResendUserActivation = ({ config }: UseResendUserActivationOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: resendUserActivation,
    onSuccess: (data, vars, onRes, ctx) => {
      config?.onSuccess?.(data, vars, onRes, ctx)
    },
    onError: (error: AxiosError<PublicDto['ExceptionDetails']>, vars, onRes, ctx) => {
      handleApiError(error)
      config?.onError?.(error, vars, onRes, ctx)
    },
  })
}
